import React from "react";
import courses from "../../data/batches.json";
import { useLanguage } from "../../i18n/LanguageContext";
import { fillTemplate } from "../../Components/RichText";

const BatchSelector = ({ selectedBatch, onBatchSelect, setToNextStep }) => {
  const { lang, content, formatNumber } = useLanguage();
  const t = content.ui.admission;
  const currency = content.ui.payment.currency;

  const handleBatchSelection = (batch, course) => {
    onBatchSelect(batch, course);
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <h2 className="text-2xl font-serif font-bold text-primary mt-6 mb-10">{t.selectHeading}</h2>

      <div className="space-y-8 w-full max-w-4xl">
        {courses.map((course, index) => (
          <div key={index} className="bg-white/50 rounded-xl p-6 border border-secondary/20">
            <h3 className="text-lg font-semibold text-primary mb-4">{course.name[lang]}</h3>
            <p className="text-sm text-accent mb-4">{fillTemplate(t.monthlyFee, { price: `${formatNumber(course.pricing)} ${currency}` })}</p>
            <div className="flex flex-wrap gap-3 items-center justify-center">
              {course.batches.map((batch, batchIndex) => (
                <button
                  key={batchIndex}
                  onClick={() => handleBatchSelection(batch, course)}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-all 
                    ${selectedBatch.telegramLink === batch.telegramLink 
                      ? 'bg-primary text-white shadow-md' 
                      : 'bg-secondary/20 text-textDark hover:bg-secondary/40 border border-secondary/30'}
                  `}
                >
                  {batch.name[lang]}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      <p className="mt-8 text-sm text-accent text-center max-w-md">
        {t.batchNote}
      </p>

      <button 
        className="mt-8 px-8 py-3 bg-primary text-white font-semibold rounded-lg hover:bg-primaryLight transition-colors shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={() => setToNextStep(2)}
        disabled={!selectedBatch}
      >
        {t.continue}
      </button>
    </div>
  );
};

export default BatchSelector;
